import { MYLIST_APP } from "../constants/constants";

export const userActions = item => {
    if (!item || !item?.actions) return [];
    const isUsedByUser = a => {
        return item.actions.filter(a => a.action === a).length > 0
    }
    const allActions = item.tag.actions.map(a => { return { action: a.name, isUsed: isUsedByUser(a.name)} });
    return allActions;
}

// Items serialize `data` and `tag.dataInfo` as JSON strings. The tags slice
// additionally exposes the parsed schema as `tag.data_info`.
const parseJson = (value, fallback) => {
    if (value === null || value === undefined) return fallback;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(value);
    } catch (e) {
        return fallback;
    }
}

export const getItemData = item => parseJson(item?.data, {}) || {};

export const getTagDataInfo = tag => {
    if (!tag) return [];
    if (Array.isArray(tag.data_info)) return tag.data_info;
    const parsed = parseJson(tag.dataInfo, []);
    return Array.isArray(parsed) ? parsed : [];
}

export const getItemImageFilename = item => {
    const imageProperty = getTagDataInfo(item?.tag).find(di => di.type === 'image');
    if (!imageProperty?.name) return null;
    return getItemData(item)[imageProperty.name] || null;
}

export const imageUrl = filename => filename ? `${MYLIST_APP.S3_BUCKET_HOST}/${filename}` : null;

export const getItemImageUrl = item => imageUrl(getItemImageFilename(item));

// A plain string property literally named "description" is shown as the
// item summary. Other schemas simply have no summary text.
export const getDescriptionProperty = item =>
    getTagDataInfo(item?.tag).find(di => di.type === 'string' && di.name?.toLowerCase() === 'description') || null;

export const getItemDescription = item => {
    const property = getDescriptionProperty(item);
    if (!property) return null;
    const value = getItemData(item)[property.name];
    return typeof value === 'string' && value.trim() ? value : null;
}

// Turns raw schema/API keys ("release_date", "want to read") into
// sentence-case labels ("Release date", "Want to read") without changing
// the underlying key.
export const formatLabel = value => {
    if (value === null || value === undefined) return '';
    const text = String(value)
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .split(/[_\s]+/)
        .filter(s => s.length > 0)
        .join(' ');
    return text ? `${text[0].toUpperCase()}${text.slice(1)}` : '';
}

export const getUserActionNames = item => (item?.actions || []).map(a => a.action).filter(Boolean);

export const hasUserDoneAction = (item, actionName) => getUserActionNames(item).includes(actionName);

// actionStats is a set of { action, count } entries; keep every entry.
export const getActionStats = item =>
    (item?.actionStats || []).filter(a => a && a.action !== undefined && a.action !== null);

export const itemEditLink = (item, propertyName) => {
    const update = (item?.itemUpdates || []).find(iu => iu.property === propertyName);
    return update ? `/item-update/${update.id}` : `/create-item-update/${item.id}/${propertyName}`;
}
